import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { EmptyClientContactPerson } from "./EmptyClientContactPerson";
import { IModel1 } from "./ClientContactPerson";
import { EmptyFilter, Filter, IFilterContactPerson } from "./Filter";
import { JVCheck } from "../../shared/JVCheck";
import { Mail } from "./Mail";
import { TnfrHistory } from "./TnfrHistory";
import { IClientTnfr } from "../clientTransfer/ClientTnfr";
import { format } from "date-fns";
import { MutualClientTransfer } from "./MutualClientTransfer";
import { ILogin, IPermissionProps } from "../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { MultipleTransfer } from "./MultipleTransfer";
import { MultipleTransferHead } from "./MultipleTransferHead";
import { MultipleTransferSales } from "./MultipleTransferSales";
import { IClientCompanyDropdown } from "../../models/IDropdown";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { safeFormatDate } from "../../models/DateFormatMapper";

interface Iprops {
    setModal: (modal: IModel1) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IClientTnfr>, loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [filters, setFilters] = useState<IFilterContactPerson>(EmptyFilter);
    const [selectedClients, setSelectedClients] = useState<Array<number>>([]);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 0,
        page: 1,
        sortField: 'contact_Person_ID',
        sortOrder: -1
    });
    // const [filter, setFilter] = useState(false);
    // const hideFilterDialog = () => {
    //     setFilter(false);
    // };
    const [tHistory, setTHistory] = useState({ contactPerson: 0, company: 0, open: false });
    const hideTHistory = () => {
        setTHistory({ contactPerson: 0, company: 0, open: false });
    }
    const [transfer, setTransfer] = useState<{ salesPerson_Company_ID?: number, contactPerson?: number, salesManagerFrom?: number, contactPersonName?: string, open?: boolean }>({ salesPerson_Company_ID: 0, contactPerson: 0, contactPersonName: '', open: false });
    const hideTransfer = () => {
        setTransfer({ salesPerson_Company_ID: 0, contactPerson: 0, contactPersonName: '', open: false });
    }
    const [mail, setMail] = useState({ data: [], open: false } as {
        data: Array<{ contactPersonID: number, contactPersonName: string, contactPersonEmail: string }>
        open: boolean
    });
    const hideMailDialog = () => {
        setMail({ data: [], open: false });
    };
    const [mct, setMCT] = useState(false);
    const hideMCTDialog = () => {
        setMCT(false);
    };

    useEffect(() => {
        if (lazyParams.rows) {
            getTableDataCount();
            loadTableData();
        }
        setSelectedClients([]);
    }, [lazyParams, filters, props.reload]);

    useEffect(() => {
        loadRowsCount();
    }, []);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadRowsCount = async () => {
        const response = await Fetch("Website_Settings/getSetting", "GET", null, `settingKey=${"CP-LIST"}`, props.toast);
        if (response) {
            const rowsCount = parseInt(await response.text(), 10);
            setLazyParams((lp) => {
                return { ...lp, rows: rowsCount }
            });
        } else {
            setLazyParams((lp) => {
                return { ...lp, rows: 0 }
            });
        }
    }

    const getTableDataCount = async () => {
        let FilterBackend: any = {
            fromDate: filters.fromDate,
            toDate: filters.toDate,
            branch_ID: undefined,
            company_ID: undefined,
            vendor_Company_ID: filters.company?.vendor_Company_ID,
            city_ID: filters.city_ID,
            state_ID: filters.state_ID,
            email: filters.email,
            majorSkill: filters.majorSkill,
            salesPerson_Company_ID: filters.salesPerson_Company_ID,
            salesPerson_Branch_ID: filters.salesPerson_Branch_ID,
            sales_Person_Id: filters.sales_Person_Id,
        };
        const response = await Fetch("Sub_Vendor_Contact_Person_Mast/count", "GET", null, `filter=${JSON.stringify(FilterBackend)}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        let FilterBackend: any = {
            fromDate: filters.fromDate,
            toDate: filters.toDate,
            branch_ID: undefined,
            company_ID: undefined,
            vendor_Company_ID: filters.company?.vendor_Company_ID,
            city_ID: filters.city_ID,
            state_ID: filters.state_ID,
            email: filters.email,
            majorSkill: filters.majorSkill,
            salesPerson_Company_ID: filters.salesPerson_Company_ID,
            salesPerson_Branch_ID: filters.salesPerson_Branch_ID,
            sales_Person_Id: filters.sales_Person_Id,
        };
        const response = await Fetch("Sub_Vendor_Contact_Person_Mast", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(FilterBackend)}`, props.toast);
        if (response) {
            const data: any = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyClientContactPerson });
    };
    const onUpdateloadClientCompany = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            let obj: IClientCompanyDropdown = {};
            obj.vendor_Company_ID = data[0].vendor_Company_ID
            obj.vendor_Company_Name = data[0].vendor_Company_Name;
            obj.website_URL = data[0].website_URL;

            return obj;
        }
    }
    const openEdit = async (data: any) => {
        let result = await onUpdateloadClientCompany(data.vendor_Company_Name);
        data.vendor_Company = result;
        props.setModal({ open: true, singleData: data });
    };
    const newEdit = (rowData: IClientTnfr) => {
        return <span className="pi pi-pencil text-blue-500" onClick={() => openEdit(rowData)}></span>
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const sendMail = () => {
        if (selectedClients.length === 0) {
            props.toast.current.show({ severity: 'error', detail: "Select Client Contact Person.", life: 3000 });
        } else if (selectedClients.length > 20) {
            props.toast.current.show({ severity: 'error', detail: "You can't send mail to more than 20 contacts at once, please select less.", life: 3000 });
        } else {
            const _data: Array<{ contactPersonID: number, contactPersonName: string, contactPersonEmail: string }> = [];
            tableData.tableData.forEach((td) => {
                if (td.contact_Person_Id && td.contact_Person_Name && td.contact_Person_EmailID && selectedClients.includes(td.contact_Person_Id)) {
                    _data.push({ contactPersonID: td.contact_Person_Id, contactPersonName: td.contact_Person_Name, contactPersonEmail: td.contact_Person_EmailID });
                }
            });
            setMail({ data: _data, open: true });
        }
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                <React.Fragment>
                    <Button label="SendMail" icon="pi pi-envelope" className="p-button-info mr-2" onClick={sendMail} />
                </React.Fragment>
                <React.Fragment>
                    <Button label="MCT" icon="pi pi-share-alt" className="p-button-info mr-2" onClick={() => setMCT(true)} />
                </React.Fragment>
                {props.permissions.is_Export && <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment>}
            </>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Client Contact Person</h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
        </div>
    );

    const selectHead = () => {
        return (
            <span onClick={() => {
                if (tableData.tableData.length === selectedClients.length) {
                    setSelectedClients([]);
                } else {
                    const temp: Array<number> = [];
                    tableData.tableData.forEach((data) => {
                        const currentDate = format(new Date(), 'dd/MM/yyyy').toUpperCase();
                        const lastMailDate = data.send_Date ? format(new Date(data.send_Date), 'dd/MM/yyyy').toUpperCase() : "";
                        if (data.contact_Person_Id && currentDate !== lastMailDate) temp.push(data.contact_Person_Id)
                    });
                    setSelectedClients(temp);
                }
            }}>
                <JVCheck name="select_all_clients" defaultValue={tableData.tableData.length > 0 && tableData.tableData.length === selectedClients.length}></JVCheck>
            </span>
        );
    }
    const onSelect = (rowData: IClientTnfr, currentDate: string, lastMailDate: string) => {
        if (rowData.contact_Person_Id) {
            if (selectedClients.includes(rowData.contact_Person_Id)) {
                const temp = selectedClients.filter((t) => { return t !== rowData.contact_Person_Id });
                setSelectedClients(temp);
            } else {
                if (currentDate === lastMailDate) {
                    props.toast.current.show({ severity: 'info', detail: `You have already send a mail today to "${rowData.contact_Person_Name}"`, life: 3000 });
                } else {
                    const temp = [...selectedClients];
                    temp.push(rowData.contact_Person_Id);
                    setSelectedClients(temp);
                }
            }
        }
    }
    const select = (rowData: IClientTnfr) => {
        const currentDate = format(new Date(), 'dd/MM/yyyy').toUpperCase();
        const lastMailDate = rowData.send_Date ? format(new Date(rowData.send_Date), 'dd/MM/yyyy').toUpperCase() : "";
        return (<>{currentDate === lastMailDate ?
            <Button icon="pi pi-check" disabled className="p-button-rounded p-button-success p-button-text" />
            : <span onClick={() => onSelect(rowData, currentDate, lastMailDate)}>
                <JVCheck name={rowData.contact_Person_EmailID} defaultValue={rowData.contact_Person_Id !== undefined && selectedClients.includes(rowData.contact_Person_Id)}></JVCheck>
            </span>}</>
        );
    }

    const add_Date = (rowData: IClientTnfr) => {
        let date;
        if (rowData.add_Date) date = format(new Date(rowData.add_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const reqPostedDate = (rowData: IClientTnfr) => {
        let date;
        if (rowData.reqPostedDate) date = format(new Date(rowData.reqPostedDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const lastMail = (rowData: IClientTnfr) => {
        let date;
        if (rowData.send_Date) date = format(new Date(rowData.send_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        let bg = rowData.send_Status ? "green" : "red";
        return (<><div style={{ height: '10px', width: '10px', borderRadius: '50%', background: bg }}> </div>{date}</>);
    };
    const openTHistory = (rowData: IClientTnfr) => {
        rowData.contact_Person_Id && setTHistory({ contactPerson: rowData.contact_Person_Id, company: rowData?.salesPerson_Company_Id || 0, open: true });
    }
    const contact_Person_Name = (rowData: IClientTnfr) => {
        return (
            <span onClick={() => openTHistory(rowData)}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.contact_Person_Name}
            </span>
        );
    }
    const clientTransferBtn = (rowData: IClientTnfr) => {
        // console.log(rowData);
        return (
            <div className="actions">
                <Button icon="pi pi-share-alt" className="p-button-rounded p-button-success p-button-text mr-1"
                    onClick={() => {
                        if (rowData.contact_Person_Id && rowData.contact_Person_Name)
                            setTransfer({ salesPerson_Company_ID: rowData.salesPerson_Company_Id, contactPerson: rowData.contact_Person_Id, salesManagerFrom: rowData.sales_Person_Id, contactPersonName: rowData.contact_Person_Name, open: true });
                    }} />
            </div>
        );
    };

    const toggleVal = async (contact_Person_Id: number | IClientTnfr, toggle_type: number) => {
        const response = await Fetch("Sub_Vendor_Contact_Person_Mast/togglestatus", "PUT", null, `contact_Person_Id=${contact_Person_Id}&toggle_type=${toggle_type}`, props.toast);
        if (response) {
            let message: string = " Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    };
    const rejectFunc = () => {
        props.toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 })

    }
    const confirmDelete = (rowData: any) => {
        confirmDialog({
            message: `Are you sure you want to Enable/Disable Share PV`,
            header: 'Confirm ',
            icon: 'pi pi-exclamation-triangle',
            // defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept: () => toggleVal(rowData.contact_Person_Id, 1),
            reject: () => rejectFunc()
        });
    }

    const vendor_TStatus = (rowData: any) => {
        return ((_roles.includes(1) || _roles.includes(26)) ?
            <span style={{ color: rowData.disable_Share_PV ? 'green' : 'red' }} className="cursor-pointer" onClick={() => { confirmDelete(rowData); }}>{rowData.disable_Share_PV ? "Yes" : "No"}</span> :
            <span style={{ color: rowData.disable_Share_PV ? 'green' : 'red' }} className="cursor-pointer" >{rowData.disable_Share_PV ? "Yes" : "No"}</span>
        )

    };

    const DateFormat = loginObj?.date_Format;

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IFilterContactPerson) => setFilters(filters)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows  scrollHeight="70vh"
                value={tableData.tableData} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[lazyParams.rows]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Client Contact Person found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column field="select" header={selectHead} body={select} />
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(20)) && <Column field="salesPerson" header="Sales Person" style={{ minWidth: '10rem' }} sortable />}
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(20)) && <Column field="salesPerson_Company_Name" header="Sales Company" style={{ minWidth: '11rem' }} sortable />}
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(20)) && <Column field="salesPerson_BranchName" header="Sales Branch" style={{ minWidth: '9rem' }} sortable />}
                {/* <Column field="contact_Person_EmailID" header="Email" />
                <Column field="cell_No" header="Cell No" />
                <Column field="phone_No" header="Phone No" /> */}
                <Column field="contact_Person_Name" header="Contact Person" style={{ minWidth: '12rem' }} sortable body={contact_Person_Name} />
                <Column field="vendor_Company_Name" header="Company Name" style={{ minWidth: '14rem' }} sortable />
                <Column field="major_Technology" header="Major Skills" style={{ minWidth: '6rem' }} />
                <Column field="city_Name" header="City" style={{ minWidth: '8rem' }} />
                <Column field="state_Name" header="State" style={{ minWidth: '2rem' }} />
                {(_roles.includes(1) || _roles.includes(26)) && <Column field="contact_Person_EmailID" header="Email" style={{ minWidth: '17rem' }} />}
                {/* <Column field="add_Date" header="Added Date" body={add_Date} sortable style={{ minWidth: '9rem' }} /> */}
                <Column field="add_Date" header="Added Date" sortable style={{ minWidth: "17rem" }} body={(rowData: any) => safeFormatDate( rowData.add_Date, undefined, DateFormat)} />
                <Column field="noofReq" header="Req#" sortable />
                <Column field="noOfServe" header="Serv#" sortable />
                <Column field="noOfResume" header="Sub#" sortable />
                <Column field="noEndClient" header="ECS#" sortable />
                <Column field="noOfECI" header="ECI#" sortable />
                <Column field="noOfPO" header="PO#" sortable />
                <Column field="wtg" header="WTG#" sortable />
                <Column field="rmngdays" header="Remaining Days#" sortable />
                <Column field="disable_Share_PV" header="Disable Share PV" sortable body={vendor_TStatus} />

                <Column field="reqPostedDate" header="Recent Posted" body={reqPostedDate} />
                <Column field="lastMail" header="Last Mail" body={lastMail} />
                <Column field="clientTransferBtn" body={clientTransferBtn} />
                {props.permissions.is_Update && <Column header="Action" body={newEdit} />}
            </DataTable>
            <ConfirmDialog />
            <MutualClientTransfer salesPerson_Company_ID={transfer.salesPerson_Company_ID} contactPerson={transfer.contactPerson} salesManagerFrom={transfer.salesManagerFrom} contactPersonName={transfer.contactPersonName} open={transfer.open} toast={props.toast} hideDialog={hideTransfer} reload={props.reload} setReload={props.setReload} />
            <TnfrHistory contactPerson={tHistory.contactPerson} hideDialog={hideTHistory} open={tHistory.open} company={tHistory.company}></TnfrHistory>
            {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setFilters={(filters: string | null) => setFilters(filters)} /> */}
            <Mail data={mail.data} open={mail.open} hideDialog={hideMailDialog} toast={props.toast} reload={props.reload} setReload={props.setReload} />
            {(_roles.includes(1) || _roles.includes(26)) ? <MultipleTransfer open={mct} hideDialog={hideMCTDialog} toast={props.toast} reload={props.reload} setReload={props.setReload} />
                : (_roles.includes(5) || _roles.includes(11)) ? <MultipleTransferHead open={mct} hideDialog={hideMCTDialog} toast={props.toast} reload={props.reload} setReload={props.setReload} />
                    : <MultipleTransferSales open={mct} hideDialog={hideMCTDialog} toast={props.toast} reload={props.reload} setReload={props.setReload} />}
        </>
    );
}
